<button class="syn-close-dialog" mat-icon-button mat-dialog-close>
    <mat-icon svgIcon="close"></mat-icon>
</button>

<h2 mat-dialog-title>Supprimer la metadata ?</h2>

<form (ngSubmit)="onDelete()">
    <mat-dialog-content>
            <p>La valeur de la clé sera supprimée. Cette opération est <strong>irréversible</strong>.<br>
                Pour supprimer la metadata, saisissez le nom de la clé:</p><pre class="pre-delete-dialog">{{ data.key }}</pre>
        <mat-form-field appearance="outline" style="width:100%" class="magicbox-field">
            <mat-label>Nom de la clé</mat-label>
            <input matInput [(ngModel)]="typedKey" name="typedKey" autocomplete="off">
        </mat-form-field>
    </mat-dialog-content>

    <div mat-dialog-actions fxLayout="row" fxLayoutAlign="flex-end" fxLayoutGap="5px">
        <button mat-button mat-dialog-close>Annuler</button>
        <button mat-button type="submit" name="action" [disabled]="data.key !== typedKey">Supprimer</button>
    </div>
</form>
